import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import Swiper, { Autoplay } from 'swiper';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';

import { Breakpoint, ButtonTheme } from '../../enums';
import { FullscreenSlide } from '../../interfaces';
import { Button } from '../button/button.component';
import { swiperSlideTag } from '../swiperSlideElement/swiperSlideElement.component';

import { 
  ButtonContainer, 
  ButtonWrapper, 
  ChildrenContainer,  
  Container, 
  Header, 
  MobileContentContainer, 
  MobileHeader, 
  Slide, 
  StyledAddToFavouriteBadge, 
  SwiperWrapper, 
  TopOverlayMask 
} from './fullscreenSlider.styled';
import { FullscreenSliderProps } from './fullscreenSlider.types';

export const FullscreenSlider: React.FC<FullscreenSliderProps> = (props: FullscreenSliderProps) => {
  const { slides, slideHeight = '100vh', className }: FullscreenSliderProps = props;
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });
  Swiper.use([Autoplay]);

  return (
    <Container className={className}>
      <SwiperComponent
        spaceBetween={0}
        slidesPerView={1}
        speed={700}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        noSwipingSelector='button'
        watchSlidesProgress
        loop
      >
        {slides.map((slide: FullscreenSlide, index: number): JSX.Element => (
          <SwiperWrapper key={index}>
            <SwiperSlide tag={swiperSlideTag} style={{ width: '100%', height: 'auto' }}>
              <Slide $backgroundImage={slide.image} $slideHeight={isSmallMobile ? '462px' : slideHeight}>
                <TopOverlayMask />
                {!isSmallMobile && (
                  <ChildrenContainer>
                    {slide.header && <Header>{slide.header}</Header>}
                    {(slide.buttonSettings || slide.secondButtonSettings) && (
                      <ButtonWrapper>
                        {slide.buttonSettings && (
                          <ButtonContainer {...slide.buttonSettings}>
                            <Button label={slide.buttonSettings.label ?? ''} />
                          </ButtonContainer>
                        )}
                        {slide.secondButtonSettings && (
                          <ButtonContainer {...slide.secondButtonSettings}>
                            <Button label={slide.secondButtonSettings.label ?? ''} buttonTheme={ButtonTheme.SecondaryTransparentBig} />
                          </ButtonContainer>
                        )} 
                      </ButtonWrapper>
                    )}
                  </ChildrenContainer>
                )}
                {slide.favouriteBadgeDetails && (<StyledAddToFavouriteBadge {...slide.favouriteBadgeDetails} />)}
              </Slide>
              {isSmallMobile && (
                <MobileContentContainer>
                  <MobileHeader>{slide.header}</MobileHeader>
                  {(slide.buttonSettings || slide.secondButtonSettings) && (
                    <ButtonWrapper>
                      {slide.buttonSettings && (
                        <ButtonContainer {...slide.buttonSettings}>
                          <Button label={slide.buttonSettings.label ?? ''} buttonTheme={ButtonTheme.PrimarySmall} />
                        </ButtonContainer>
                      )}
                      {slide.secondButtonSettings && (
                        <ButtonContainer {...slide.secondButtonSettings}>
                          <Button label={slide.secondButtonSettings.label ?? ''} buttonTheme={ButtonTheme.SecondarySolidSmall} />
                        </ButtonContainer>
                      )} 
                    </ButtonWrapper>
                  )}
                </MobileContentContainer>
              )}
            </SwiperSlide>
          </SwiperWrapper>
        ))}
      </SwiperComponent>
    </Container>
  );
};
